import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import CustomSwitch, { CustomSwitchProps } from './CustomSwitch';

interface ClientFormControlProps extends CustomSwitchProps {
  className: string;
  label: JSX.Element | string;
  typographyClassName: string;
}

const ClientFormControl: React.FC<ClientFormControlProps> = ({
  id,
  checked,
  label,
  className,
  typographyClassName,
  handleChange,
}) => {
  return (
    <FormControlLabel
      className={className}
      control={
        <CustomSwitch id={id} checked={checked} handleChange={handleChange} />
      }
      label={<Typography className={typographyClassName}>{label}</Typography>}
    />
  );
};

export default ClientFormControl;
